export const API_CLINICS = 'core/clinics';
export const API_CLINICS_THRESHOLD = 'core/clinics/thresholds';
export const API_ADMIN_PANEL_CLINICS = 'core/admin-panel/clinics';
export const API_ADMIN_PANEL_CLINICS_UPDATE_STATUS =
  'core/admin-panel/clinics/toggle-status';
export const API_CLINICS_RUNBOOK_LOGS = 'core/runbook-logs';
